import PortfolioPlaylistEditor from '../PortfolioPlaylistEditor'
import PortfolioContentEditor from '../PortfolioContentEditor'
import DndProviderWrapper from 'components/DndProviderWrapper/DndProviderWrapper'
import getPortfolioStyles from 'utils/getPortfolioStyles'
import { useEffect, useState } from 'react'

const TemplateProfileBottom = ({ values, onChange, isPreview }) => {
  const playlistStyles = getPortfolioStyles(values?.pageData?.playlistRegion)
  const contentStyles = getPortfolioStyles(values?.pageData?.contentRegion)
  const [rerenderKey, setReRenderKey] = useState(Math.random())
  const [secondKey, setSecondKey] = useState(Math.random())
  useEffect(() => {
    setReRenderKey(Math.random())
  }, [values.template])

  useEffect(() => {
    setSecondKey(Math.random())
  }, [rerenderKey])
  return (
    <div className=" template-container w-full">
      <div className="p-4 pb-4" style={playlistStyles}>
        <div className="max-w-[1280px] mx-auto">
          <DndProviderWrapper
            className="w-full h-full flex flex-col"
            key={rerenderKey}
          >
            <PortfolioPlaylistEditor
              values={values}
              onChange={onChange}
              isPreview={isPreview}
            />
          </DndProviderWrapper>
        </div>
      </div>
      <div className="px-4 pt-4 pb-10" style={contentStyles}>
        <div className="max-w-[1280px] mx-auto">
          <PortfolioContentEditor
            values={values}
            onChange={onChange}
            region="contentRegion"
            isPreview={isPreview}
          />
        </div>
      </div>
    </div>
  )
}

export default TemplateProfileBottom
